define.alias("shared/components/shared/post/secondary/caption-writer", "media/components/shared/post/secondary/caption-writer");